const EnvironmentProperties = {
    local: {
        API: 'http://localhost:8080',
        Projects: process.env.VUE_APP_LOCAL_PROJECT_BASEURL,
        Embed: `http://${window.location.host}/`,
        EmbedUseSchemaInURL: false
    },
    development: {
        API: process.env.VUE_APP_LOCAL_API_BASEURL || 'http://localhost:8080',
        Projects: process.env.VUE_APP_LOCAL_PROJECT_BASEURL,
        Embed: `http://${window.location.host}/`,
        EmbedUseSchemaInURL: false
    },
    staging: {
        API: process.env.VUE_APP_STAGING_API_BASEURL || 'https://api.staging.cliovis.com/',
        Projects: process.env.VUE_APP_STAGING_PROJECT_BASEURL || 'wss://projects.staging.cliovis.com/',
        Embed: 'https://embed.cliovis.com/',
        EmbedUseSchemaInURL: true
    },
    production: {
        API: process.env.VUE_APP_PRODUCTION_API_BASEURL || 'https://api.cliovis.com/',
        Projects: process.env.VUE_APP_PRODUCTION_PROJECT_BASEURL || 'wss://projects.cliovis.com/',
        Embed: 'https://embed.cliovis.com/',
        EmbedUseSchemaInURL: true
    }
};

// This is for hotloading environment switches.  Set it to a value to override the environment.
// If you change this, make sure that you do not commit environment.ts, as that will mess things
// up for everyone else.
const activeEnvironmentOverride = undefined;

export const ActiveEnvironmentName = (process.env.NODE_ENV === 'production' ? 'production' : (
    // Just so that we can use 'local' as an override without getting type errors
    (process.env.NODE_ENV === '_') ? 'development' :
    (activeEnvironmentOverride || process.env.VUE_APP_ACTIVE_ENVIRONMENT || process.env.NODE_ENV || 'production')
));

console.log(`Using environment ${ActiveEnvironmentName}`);

const activeEnv : {API: string, Projects: string, Embed: string, EmbedUseSchemaInURL: Boolean} = (EnvironmentProperties as any)[ActiveEnvironmentName] || EnvironmentProperties.production;
export const APIBaseURL = process.env.VUE_APP_API_BASEURL_OVERRIDE || activeEnv.API;
export const ProjectsBaseURL = process.env.VUE_APP_PROJECTS_BASEURL_OVERRIDE || activeEnv.Projects;
export const EmbedShouldUseSchemaInURL = activeEnv.EmbedUseSchemaInURL;
export const EmbedBaseURL = activeEnv.Embed;
export const IsProductionEnvironment = ActiveEnvironmentName === 'production';

if (!APIBaseURL || !ProjectsBaseURL || !EmbedBaseURL)
{
    let errorMessage = 'ERROR: Your environment is not properly configured.';
    if (!APIBaseURL) errorMessage += '  You will not be able to log in.';
    if (!ProjectsBaseURL) errorMessage += '  You will not be able to connect to projects.';
    if (!EmbedBaseURL) errorMessage += '  Embeds will not function correctly.';

    if (ActiveEnvironmentName === 'development')
    {
        errorMessage += '\n\nIf you are trying to connect to a local environment, ensure that .env.development.local is properly filled out and restart the npm server.';
    }
    
    alert(errorMessage);
}

export const IsEmbedded = process.env.VUE_APP_EMBED != undefined;
export const VersionString = "v1.0.6";

export function GetAPIUrl(route : String)
{
    if (route.startsWith('/')) route = route.substr(1);
    return APIBaseURL + route;
}
